import React, { Component } from 'react';
import { addToCart } from '../redux/Action';
import { connect } from 'react-redux';
import Axios from 'axios';
import { API_URL } from '../API_url/API_URL';
import { Button} from '@material-ui/core';
import { Modal, ModalHeader, ModalBody, ModalFooter, Table} from 'reactstrap';


class TsHistoryAd extends Component {
    state = {
        data: [],
        date: new Date().toLocaleDateString(), 
        openModal: false,
        selectedID: null
    }
    
    componentDidMount() {
            Axios.get(API_URL + `/transactions`)
            .then((res) => {
                this.setState({data: res.data})
                console.log(this.state.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderNum = (arr) => {
        let alpha = 'ABCDE'
        let arr2 = ''
        let out = []
        let output = []
        console.log(arr)
        for(var i =0; i<arr.length; i++){
            arr2 = parseInt(arr[i][1])+1
            out = (alpha[arr[i][0]] +arr2) + '; '
            output.push(out)
            
        }
        return output
    }

    renderHistory = () => {
        console.log(this.state.data)
        let { openModal } = this.state;
        return this.state.data.map((val, index) => {
            return (
                <div>
                <tr>
                    <td>{index+1}</td>
                    <td>{val.date}</td>
                    <td>{val.totalAmount}</td>
                    <td>{val.totalPrice}</td>
                    <td><Button color='secondary' onClick={() => this.setState({openModal: true})}>
                            Detail
                        </Button>
                    </td>
                </tr>
                <Modal isOpen={openModal}>
                    <ModalHeader >Transaction Detail</ModalHeader>
                    <ModalBody>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Movie title</th>
                                    <th>Seats</th>
                                    <th>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {val.detail.map((val2) => {
                                    return (
                                        <tr>
                                            <td>{index+1}</td>
                                            <td>{val2.name}</td>
                                            <td>{this.renderNum(val2.seats)}</td>
                                            <td>{val2.totalPrice}</td>
                                        </tr>
                                    )}
                                )}
                            </tbody>
                        </Table>
                    </ModalBody>
                    <ModalFooter>
                    <Button color="secondary" onClick={() => this.setState({openModal: false})}>Close</Button>
                    </ModalFooter>
                </Modal>

                </div>   
            )
        })
    }
    

    render() {
        return (
            <div className='justify-content-center'>
                <Table>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Time - Date</th>
                            <th>Ticket Amount</th>
                            <th>Total Price</th>
                            <th>Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderHistory()}
                    </tbody>
                </Table>
            </div>
        )
    }
    // transaction : [{userId: , date: , totalPrice: , ticketAmount: , Detail: [{ title: , totalthismovie: , Seatscode: , ticketAmount: }]}]
    }

const mapStatetoProps = ({auth}) => {
    return {
        idUser: auth.id,
        cart: auth.cart,
        role: auth.role
    }
}

export default connect(mapStatetoProps, { addToCart })(TsHistoryAd);